import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  AuthAccessTokenDetails,
  ILoginUserNamePasswordInput,
  LoginOAuthParams
} from '../../../models';
import {
  LoginRememberMeOperationTypes,
  RedirectfulResponse
} from '../../../models/login-remember-me.interfaces';
import { LoginPasswordlessFacadeService } from '../login-passwordless-facade-service/login-passwordless-facade.service';
import { LoginSubmitAuthenticationIdentifierService } from '../login-passwordless-facade-service/login-submit-authentication-identifier.service';
import { InitiateLoginFacadeService } from '../login-remember-me-facade-service/initiate-login-facade.service';
import { PostWithCredentialsFacadeService } from '../login-remember-me-facade-service/post-with-credentials-facade.service';
import { RedirectfulFacadeService } from '../login-remember-me-facade-service/redirectful-facade.service';
import { RedirectfulPostWithCredentialsFacadeService } from '../login-remember-me-facade-service/redirectful-post-with-credentials-facade.service';

@Injectable({
  providedIn: 'root'
})
export class LoginRememberMeWrapperService {
  flowdId = '';

  constructor(
    private postWithCredentialFacade: PostWithCredentialsFacadeService,
    private initiateLoginFacade: InitiateLoginFacadeService,
    private redirectFulFacade: RedirectfulFacadeService,
    private redirectfulPostWithCredentialsFacade: RedirectfulPostWithCredentialsFacadeService,
    private loginPasswordlessFacade: LoginPasswordlessFacadeService,
    private loginSubmitAuthenticationIdentifier: LoginSubmitAuthenticationIdentifierService
  ) {}

  initiatePingFlow(
    loginOAuthParams: LoginOAuthParams,
    operationType: LoginRememberMeOperationTypes,
    requestInput?: ILoginUserNamePasswordInput,
    appToken = false,
    eamAuthStateValue?: string,
    forcePromptLoginFlow = false
  ): Observable<
    AuthAccessTokenDetails | RedirectfulResponse | boolean | string
  > {
    let fn;

    const options = {
      INITIATE_LOGIN: () => {
        return this.initiateLoginFacade.initiateLogin(
          loginOAuthParams,
          requestInput,
          appToken,
          eamAuthStateValue,
          forcePromptLoginFlow
        );
      },
      POST_WITH_CRED: () => {
        return requestInput
          ? this.postWithCredentialFacade.postWithCredFlow(
              loginOAuthParams,
              requestInput
            )
          : of('ERROR_MSG_NO_REQUEST_INPUT_PASSED');
      },
      REDIRECTFUL_LOGIN: () => {
        const flowId = loginOAuthParams?.redirectfulFlowId ?? '';
        return this.redirectFulFacade.initiateRedirectFulLogin(
          loginOAuthParams,
          flowId,
          requestInput
        );
      },
      REDIRECTFUL_POST_WITH_CRED: () => {
        return requestInput
          ? this.redirectfulPostWithCredentialsFacade.redirectfulPostWithCredFlow(
              loginOAuthParams,
              requestInput
            )
          : of('ERROR_MSG_NO_REQUEST_INPUT_PASSED');
      },
      PASSWORDLESS_LOGIN: () => {
        return this.loginPasswordlessFacade.initiatePasswordlessLogin(
          loginOAuthParams,
          eamAuthStateValue
        );
      },
      PASSWORDLESS_LOGIN_WITH_CRED: () => {
        return requestInput
          ? this.loginSubmitAuthenticationIdentifier.submitAuthenticationIdentifier(
              loginOAuthParams,
              requestInput,
              ''
            )
          : of('ERROR_MSG_NO_REQUEST_INPUT_PASSED');
      },
      DEFAULT: () => {
        return this.initiateLoginFacade.initiateLogin(
          loginOAuthParams,
          requestInput,
          appToken,
          eamAuthStateValue
        );
      }
    };

    operationType ? (fn = options[operationType]) : (fn = options['DEFAULT']);
    return fn();
  }
}
